import React, { Component } from 'react'
import Link from '../../utils/link'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

class ArticleFeature extends Component {

  render() {

    const { feature, featuredImage, categories, title, slug, date, acf, reverse } = this.props

    let author = acf?.author?.length > 0 ? acf.author[0] : null

    return (

      <div className={`article-feature ${feature ? 'article-feature--feature' : ''}`}>

        { feature && 
          <>
            <img className='article-feature__bg article-feature__bg--mobile' src={featuredImage?.node?.sourceUrl} alt={title} />
            <img className='article-feature__bg article-feature__bg--desktop' src={featuredImage?.node?.sourceUrl} alt={title} />
          </>
        }

        <div className='article-feature__inner'>

          <div className={`article-feature__content ${reverse ? `reverse` : '' }`}>

            <div className={`article-feature__details ${reverse ? `reverse` : '' }`}>

              <div className='article-feature__heading'>
                <Link to={`/media-centre/${slug}/`}>
                  <span className='article-feature__tag'>{ categories.nodes[0].name }</span>
                  <h3 dangerouslySetInnerHTML={{ __html: title }} />
                  <p className='article-feature__date'>{date}</p>
                </Link>
              </div>

              { author &&

                <div className={`article-feature__agent ${reverse ? `reverse` : '' }`}>

                  <div className={`article-feature__thumbnail ${reverse ? `reverse` : '' }`}>
                    <img loading='lazy' src={author?.acf?.thumbnailImage?.sourceUrl} alt={title} />
                  </div>

                  <div className='article-feature__position'>

                    <ul>
                      <li className='author'>{ author.title }</li>
                    </ul>

                  </div>

                </div>

              }
              { !author && acf?.externalAuthor?.name &&

                <div className={`article-feature__agent ${reverse ? `reverse` : '' }`}>

                  <div className={`article-feature__thumbnail ${reverse ? `reverse` : '' }`}>
                    <img loading='lazy' src={acf?.externalAuthor?.image?.sourceUrl} alt={acf?.externalAuthor?.name} />
                  </div>

                  <div className='article-feature__position'>

                    <ul>
                      <li className='author'>{ acf?.externalAuthor?.name }</li>
                      <li>{ acf?.externalAuthor?.position }</li>
                    </ul>

                  </div>

                </div>

              }

            </div>
            <div className={`article-feature__link ${reverse ? `reverse` : '' }`}>
              <Link className='' to={`/media-centre/${slug}/`}>View Article</Link>
            </div>
            <div className={`article-feature__image ${reverse ? `reverse` : '' }`}>
              <img loading='lazy' src={featuredImage?.node?.sourceUrl} alt={title} />
            </div>
          </div>
        </div>

      </div>
    )
  }
}

export default ArticleFeature
